import axios from 'axios';
// import {loadEnv} from 'vite';

const apiURL = import.meta.env.VITE_API_BASE_URL;

const instance = axios.create({
  baseURL: apiURL
});

instance.interceptors.request.use(
  function (config: any) {
    const token = sessionStorage.getItem('token');
    // const lng = sessionStorage.getItem('i18nextLng') || 'en';
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // config.params = { lng };
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (401 === error?.response?.status) {
      sessionStorage.removeItem('token');
      location.reload();
    } else {
      return Promise.reject(error);
    }
  }
);

export default instance;